module.exports = __webpack_public_path__ + "img/case_7.a195543c.png";